import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { NbWindowService } from '@nebular/theme';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, filter, map, switchMap, tap, timer } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { CHANGELOG, IChangelogService } from '../../contracts/changelog';
import {
  SIDEBAR_NAVIGATION,
  SidebarNavigator,
} from '../../contracts/sidebar-navigator';
import { ChangelogModalComponent } from '../changelog-modal/changelog-modal.component';

@UntilDestroy()
@Component({
  selector: 'vmspdb-ui-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss'],
  standalone: false,
})
export class FullLayoutComponent implements OnInit {
  sidebarNavigation = inject<SidebarNavigator>(SIDEBAR_NAVIGATION);
  private changelogService = inject<IChangelogService>(CHANGELOG);
  private route = inject(ActivatedRoute);
  private swUpdate = inject(SwUpdate);
  private win = inject(NbWindowService);

  updated$: Observable<boolean>;
  version = '';

  changelog$ = this.changelogService.changelog$().pipe(shareReplay());

  constructor() {
    const swUpdate = this.swUpdate;

    this.updated$ = swUpdate.versionUpdates.pipe(
      tap((update) => console.log('[VMS] Update check', { update })),
      map((update) => update.type === 'VERSION_READY'),
      filter((update) => update),
    );
  }

  reloadServiceWorker() {
    window.location.reload();
  }

  ngOnInit(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate
        .checkForUpdate()
        .then(() => console.log('[VMS] Initial app update check'));
      // every thirty minutes
      timer(0, 1.8e6)
        .pipe(
          untilDestroyed(this),
          switchMap(() => this.swUpdate.checkForUpdate()),
          tap(() => console.log('[VMS] Checking for update')),
        )
        .subscribe();
    }

    this.version = this.route.snapshot.data['version'] ?? '[UNKNOWN]';
  }

  showChangelog() {
    this.changelog$
      .pipe(
        untilDestroyed(this),
        tap(({ releases }) => console.log({ releases })),
        tap(({ releases }) =>
          this.win.open(ChangelogModalComponent, {
            title: 'Recent Changes',
            context: {
              releases,
            },
            windowClass: 'modal-medium',
          }),
        ),
      )
      .subscribe();
  }
}
